const canUseClipboardAPI =
    typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !!navigator.clipboard &&
    window.isSecureContext; // requires https or localhost

export async function safeCopy(text: string): Promise<boolean> {
    try {
        if (canUseClipboardAPI) {
            await navigator.clipboard!.writeText(text);
            return true;
        }
        // Fallback for http / unsupported envs
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
    } catch {
        return false;
    }
}
